import axios from 'axios';

import { IPieTipsItem, ITipItem } from '../components/tools/life-balance-wheel/types';

interface IBWHelper {
  id: string;
  default: boolean;
  status: string;
  sort: number;
  name: string;
  qwestions?: IBWQwestion[];
}

interface IBWQwestion {
  id: string;
  balance_wheel_helper: string;
  sort: number;
  description: string | null;
  title: string | null;
  formatted_text: string | null;
}

const emptyHelper: IBWHelper = {
  id: '0',
  default: false,
  status: 'published',
  sort: -1,
  name: '',
};
const defaultBWHelperList: IBWHelper[] = [
  emptyHelper,
  emptyHelper,
  emptyHelper,
  emptyHelper,
  emptyHelper,
  emptyHelper,
  emptyHelper,
  emptyHelper,
  emptyHelper,
];

export const loadWheelTips = async (): Promise<{ items: IPieTipsItem[]; index: number }> => {
  const MarkDownFilter = (sIn: string) => {
    if (sIn.trim().length === 0) return '';
    let result = sIn.trim().split('<br>').join('\n ');
    result = result.split('\n\n').join('   \n   \n');

    if (result[0] === '#') {
      result = `\n${result}`;
    }

    return result;
  };
  const result = [...defaultBWHelperList];
  try {
    const res = await axios.get(`${import.meta.env.VITE_REACT_APP_TIPS_URL}/items/balance_wheel_helpers`, {});

    const data: IBWHelper[] = res?.data ? res.data.data : [];
    const tmp = data.filter((v: IBWHelper) => v.status === 'published');
    tmp.forEach((v) => {
      const ind = v.sort - 1;
      if (ind > -1 && ind < 9 && result[ind].sort === -1) {
        result[ind] = v;
      }
    });
  } catch (e) {
    console.error('error during loading tips for Life Balance Wheel:', e);
  }
  try {
    const res = await axios.get(`${import.meta.env.VITE_REACT_APP_TIPS_URL}/items/balance_wheel_helper_questions`, {});
    const tmp: IBWQwestion[] = res.data.data ?? [];
    result.forEach((v) => {
      v.qwestions = tmp.filter((t) => t.balance_wheel_helper === v.id).sort((a, b) => a.sort - b.sort);
    });
  } catch (e) {
    console.error('error during loading tips for Life Balance Wheel:', e);
  }

  let index = 1;
  const items: IPieTipsItem[] = result.map((v, i) => {
    if (v.default) {
      index = i;
    }
    const tips: ITipItem[] = (v.qwestions ?? []).map((q) => ({
      qwestion: q.title ?? '',
      note: q.description ?? '',
      richtext: q.formatted_text === null ? undefined : MarkDownFilter(q.formatted_text),
    }));

    console.log(
      '@@',
      i,
      '::',
      tips.filter((v) => !v.richtext).map((v) => v.qwestion.length + v.note.length),
    );

    return {
      title: v.name,
      tips,
    };
  });

  return { items, index };
};
